import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { Router } from '@angular/router';
import { ENVOIRNMENT } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {
  private appInsights: ApplicationInsights;

  constructor(private router: Router) {
    const angularPlugin = new AngularPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: ENVOIRNMENT.baseUrls.instrumentationKey,
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: { router: this.router }
        },
        enableAutoRouteTracking: true, // Enable automatic route tracking
        disableExceptionTracking: false,
      }
    });
    this.appInsights.loadAppInsights();
  }

  // // New method to log exceptions
  // logException(error: any, properties?: { [key: string]: any }): void {
  //   let exception: Error;
  //   if (error instanceof Error) {
  //     exception = error;
  //   } else {
  //     exception = new Error(error?.toString() || 'Unknown error');
  //   }
  //   this.appInsights.trackException({ exception, properties });
  // }
  private debounceTimeout: any;

  // logException(error: any, properties?: { [key: string]: any }): void {
  //   clearTimeout(this.debounceTimeout);
  //   this.debounceTimeout = setTimeout(() => {
  //     let exception: Error;
  //     if (error instanceof Error) {
  //       exception = error;
  //     } else {
  //       exception = new Error(error?.toString() || 'Unknown error');
  //     }
  //     this.appInsights.trackException({ exception, properties });
  //   }, 1000); // Adjust the timeout as needed
  // }

  private recentErrors: { [key: string]: number } = {};

  logException(error: any, properties?: { [key: string]: any }): void {
    const errorKey = error?.toString() || 'Unknown error';
    const now = Date.now();

    // Check if the error was logged recently
    if (this.recentErrors[errorKey] && (now - this.recentErrors[errorKey] < 60000)) {
      return; // Skip logging
    }

    // Update the timestamp for this error
    this.recentErrors[errorKey] = now;

    let exception: Error;
    if (error instanceof Error) {
      exception = error;
    } else {
      exception = new Error(errorKey);
    }

    try {
      this.appInsights.trackException({ exception, properties });
    } catch (loggingError) {
      console.error('Failed to log exception to Application Insights:', loggingError);
    }
  }
}
